import React from 'react'
import { ICellRendererParams, IRowNode } from 'ag-grid-community'
import { StatusCell } from 'view/shared/datagrid'
import { getLiveStatusText, getLiveStatusColor } from 'view/routes/requests/shared/utils'
import { AuditDetail, AuditStatus } from 'api'
import { Locale, Translation } from 'locale'

interface AuditStatusRendererProps extends ICellRendererParams {
  isGroupByLevel?: boolean
}

export class AuditStatusRenderer extends React.Component<AuditStatusRendererProps> {
  render() {
    const { node, isGroupByLevel } = this.props

    if (!node.data) {
      return null
    }

    const isGroup = isGroupByLevel && node.allLeafChildren ? node.level < this.getHighestChildLevel(node.allLeafChildren) : !!node.group

    const color = isGroup ? 'white' : getLiveStatusColor(node.data, false)
    const text = isGroup ? this.getAuditStatusText(node.data) : getLiveStatusText(node.data)
    const tooltip = ''

    return <StatusCell color={color} text={text} tooltip={tooltip} />
  }

  private getHighestChildLevel = (leafChildren: IRowNode[]) => {
    return leafChildren.reduce((acc, leafChild) => (leafChild.level > acc ? leafChild.level : acc), 0)
  }

  private getAuditStatusText = (auditDetail: AuditDetail) => {
    switch (auditDetail.auditStatus) {
      case AuditStatus.COMPLETED:
        return Locale.translate(Translation.TC_COMPLETED)

      case AuditStatus.ONGOING:
        return Locale.translate(Translation.TC_ONGOING)

      default:
        return '-- --'
    }
  }

  refresh = () => {
    this.forceUpdate()
    return true
  }
}
